import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import moment from 'moment';
import 'moment/locale/de'
import "./social.scss";

moment.locale('de')

const Social = () => {

    const [instagramData, setInstagramData] = useState(null);
    const [visiblePosts, setVisiblePosts] = useState(8); // State to track visible posts

    const accessToken = 'IGAASZCD8IK4sBBZAFNFSk8tU21fNkFvX01sbTlzMng2ZATMtT3ZABak1BajQ4YTU1eWw2eHF5ODJQYlVZAREJOU09fRlpEd3NkZA1VOMDZAzbl91LXEtWlNBV2Q3bXJJYkRRTm5Da0VqOHVrWnlodGxfeEh1SHJXUWRiTkFXdlZABSU9EawZDZD'
    const fields = 'id,caption,media_type,media_url,thumbnail_url,permalink,username,like_count,comments_count,timestamp,children';

    useEffect(() => {
        // Hier können Sie den erhaltenen OAuth 2.0-Token verwenden, um auf Instagram-Daten zuzugreifen.
        fetch(`https://graph.instagram.com/me/media?fields=${fields}&is_shared_to_feed=true&access_token=${accessToken}`)
            .then(response => response.json())
            .then(data => {
                const lastHundredPosts = data.data;
                setInstagramData({ data: lastHundredPosts });
            })
            .catch(error => console.error('Error:', error));
    }, []);

    // Function to load more posts
    const loadMorePosts = () => {
        setVisiblePosts(prev => prev + 6);
    }

    return (
        <div className='social'>
            <div className="container">
                <h1>Neues von Uns</h1>
                <div className="grid">
                    {instagramData && instagramData.data && instagramData.data.slice(0, visiblePosts).map((item, index) => {
                        const delay = (index % 5) * 0.1;

                        return (
                            <motion.div
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay }}
                                key={item.id}
                            >
                                <Link
                                    className="item"
                                    to={item.permalink}
                                    target="blank"
                                >
                                    <div className="top">
                                        <img src="/assets/logo.svg" alt="Profilbild" />
                                        <span>{item.username}</span>
                                    </div>
                                    {item.media_type === 'VIDEO' ? (
                                        <div className="video">
                                            <video alt={item.caption} poster={item.thumbnail_url} muted loop controls >
                                                <source src={item.media_url} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            <span className="carousel"><PlayCircleIcon /></span>
                                        </div>
                                    ) : (
                                        <div className="image">
                                            <img src={item.media_url} alt={item.caption} />
                                            {item.media_type === 'CAROUSEL_ALBUM' && (
                                                <span className="carousel"><PhotoLibraryIcon /></span>
                                            )}
                                        </div>
                                    )}
                                    <div className="bottom">
                                        <div className="symbols">
                                            <span>
                                                <FavoriteBorderOutlinedIcon />
                                                {item.like_count}
                                            </span>
                                            <span>
                                                <ChatBubbleOutlineOutlinedIcon />
                                                {item.comments_count === 0 ? "" : item.comments_count}
                                            </span>
                                            <SendOutlinedIcon />
                                        </div>
                                        <div className="caption">
                                            <span>{item.caption.split('\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    <br />
                                                </React.Fragment>
                                            ))}</span>
                                        </div>
                                    </div>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
                {instagramData && instagramData.data && visiblePosts < instagramData.data.length && (
                    <button className='loadMore' onClick={loadMorePosts}>Mehr anzeigen</button>
                )}
            </div>
        </div>
    )
}

export default Social;
